export function tokenPrice(n) {
    return tokenPriceM(Math.floor(n / 1e6))
}

export function tokenPriceM(n) {
    return Math.pow(1 + n, 0.3)
}

function priceForStep(step) {
    return tokenPriceM((step-1) * STEP)
}

const STEP = 1
const MKR_BUY_FEE = 0.1
const PRESALE_FACTOR = 0.1
const CHT_FEE = 0.3
const CHT_AGENT_FEE = 0.1
const INVESTOR_SHARE = 0.6
const XAT_SHARE = 0.0
const CHARITY_SHARE = 0.1
const DEVELOPMENT_SHARE = 0.1

export function profit(joinStep, currentStep) {
    const currentStepM = (1 + (currentStep-1) * STEP)
    const myPrice = priceForStep(joinStep)

    let totalPrice = 0
    for(let i = 0; i < currentStepM; i++) {
        totalPrice += tokenPriceM(i)
    }
    totalPrice *= (1 - MKR_BUY_FEE)

    const systemProfit = 1.0 - CHT_AGENT_FEE
    const payoff = systemProfit * (1.0 - CHARITY_SHARE - DEVELOPMENT_SHARE)
    const yy = (1.0 - XAT_SHARE)
    const profit = (totalPrice * (CHT_FEE * payoff + PRESALE_FACTOR)) * yy * INVESTOR_SHARE / (PRESALE_FACTOR * myPrice * currentStepM)

    return profit * 100 - 100
}

export function rangePrice(start, amount) {
    const m = Math.floor(start / 1e6)
    const n = Math.floor((start + amount) / 1e6)
    if(m == n) {
        const price = tokenPriceM(m)
        console.log(`Buy ${amount} tokens at price ${price}`)
        return amount * price
    }
    else {
        const low = (m+1) * 1e6 - start
        const high = start + amount - n * 1e6
        const lowPrice = tokenPriceM(m)
        const highPrice = tokenPriceM(n)

        console.log(`Buy ${low} tokens at price ${lowPrice}`)

        let price = low * lowPrice + high * highPrice
        for(let i = m+1; i <= n-1; i++) {
            const midPrice = tokenPriceM(i)
            console.log(`Buy 1,000,000 tokens at price ${midPrice}`)
            price += 1e6 * midPrice
        }

        if(high > 0) {
            console.log(`Buy ${high} tokens at price ${highPrice}`)
        }

        return price
    }
}